import { render, staticRenderFns } from "./MathSentences.vue?vue&type=template&id=58b21ab2&scoped=true&"
import script from "./MathSentences.vue?vue&type=script&lang=js&"
export * from "./MathSentences.vue?vue&type=script&lang=js&"
import style0 from "./MathSentences.vue?vue&type=style&index=0&id=58b21ab2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b21ab2",
  null
  
)

export default component.exports